import React, { createContext, useContext, useRef } from 'react';
import { createPortal } from 'react-dom';
import { GridLayout } from '@icecreamsocial/components';

// Create a context for the portal ref so that we can retrieve it throughout the app
export const HeaderPortalContext = createContext({ portalRef: null });
